export const GET_INSTALLMENTS = "/Installment/GetInstallments"